// extracted by mini-css-extract-plugin
module.exports = {"title":"CrudList_title__3JMnm","paper":"CrudList_paper__FnA0m"};